import Channel from '@/shared/classes/channels/channel'

export const getWidevineOttChannelsIds = (
    widevineOttChannelsList: Channel[]
) => {
    const idsArray = widevineOttChannelsList.map(
        (channel: Channel) => channel.id
    )
    return idsArray
}

export const getTvChannelsList = (channels: Channel[]) => {
    if (!channels) return []
    const tvChannels = channels.filter(
        (channel: Channel) => channel.service === 1
    )

    return tvChannels
}
